module.exports = __webpack_public_path__ + "media/soundtrack.ea4222ca.mp3";